import React from "react";

export const Logo = ({ inverted = false }) => (
  <div className="logo" data-testid="brand-logo">
    <div className="logo-icon">✚</div>
    <span>
      <span className={inverted ? "logo-text-turquoise" : "logo-text-navy"}>DentaPro</span>{" "}
      <span className="logo-text-turquoise">Clinic</span>
    </span>
  </div>
);
